module.exports = __webpack_public_path__ + "static/media/Lexus.950d1200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lexus.png
// module id = 1053
// module chunks = 0